import React, { FunctionComponent } from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import Sidenav, { SidenavLink } from './Sidenav';

interface Props {
  links: Array<SidenavLink>;
}

const Container = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  margin: 12px auto;
  position: relative;
`;

const ContentContainer = styled.div`
  flex: 0.8;
`;

const ContentWithSidenav: FunctionComponent<Props> = ({ links, children }) => {
  const { path } = useRouteMatch();
  return (
    <Container>
      {links && <Sidenav links={links} path={path} />}
      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
};

export default ContentWithSidenav;
